// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iZ","advertCardNum":"c-a_ja"};